import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';
import { ILayoutConf, LayoutService } from 'app/shared/services/layout.service';
import { CommonService } from 'app/shared/services/global/common.service';

@Component({
	selector: 'app-sidebar-side',
	templateUrl: './sidebar-side.component.html',
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
	public menuItems: any[];
	public hasIconTypeMenuItem: boolean;
	public iconTypeMenuTitle: string;
	public menuItemsSub: Subscription;
	public layoutConf: ILayoutConf;

	constructor(
		public navService: NavigationService,
		public themeService: ThemeService,
		public layout: LayoutService,
		public commonService: CommonService
	) {
	}

	ngOnInit() {
		this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
		this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
			const party = JSON.parse(atob(localStorage.getItem('party_type')));
			this.menuItems = menuItem;

			// // Note :- (this.commonService.selectedItrId!=5) is added coz schedule FA not showing into itr 5 in case of firm status 
			if (this.menuItems.length && party['party_type'] === 3 && this.commonService.selectedItrId!=5 ) {
				const incomesModules = this.menuItems[1]['sub'];
				incomesModules.splice(0, 1);
				this.menuItems[1]['sub'] = incomesModules;
			}
			if (this.commonService.assessmentYear && (parseInt(this.commonService.assessmentYear, 10) === 2019)) {
				if (this.menuItems.length) {
					const deductionModules = this.menuItems;
					const deductionComponentData = deductionModules.filter(menu => menu.state === 'dashboard/deduction');
					const deductionComponentIndex = deductionModules.indexOf(deductionComponentData[0]);
					const deductionSubModules = this.menuItems[deductionComponentIndex]['sub'];
					const deductionSubComponentData = deductionSubModules.filter(menu => menu.state === 'schedule-di');
					const deductionSubComponentIndex = deductionSubModules.indexOf(deductionSubComponentData[0]);
					if (deductionSubComponentIndex >= 0) {
						deductionSubModules.splice(deductionSubComponentIndex, 1);
						this.menuItems[deductionComponentIndex]['sub'] = deductionSubModules;
					}
				}
			}

			if (this.menuItems.length && party['party_type'] === 2 && (parseInt(this.commonService.assessmentYear, 10) !== 2019)) {
				const deductionModules = this.menuItems;
				const deductionComponentData = deductionModules.filter(menu => menu.state === 'dashboard/incomes');
				const deductionComponentIndex = deductionModules.indexOf(deductionComponentData[0]);
				const deductionSubModules = this.menuItems[deductionComponentIndex]['sub'];
				const deductionSubComponentData = deductionSubModules.filter(menu => menu.state === 'salary-income');
				const deductionSubComponentIndex = deductionSubModules.indexOf(deductionSubComponentData[0]);
				if (deductionSubComponentIndex >= 0) {
					deductionSubModules.splice(deductionSubComponentIndex, 1);
					this.menuItems[deductionComponentIndex]['sub'] = deductionSubModules;
				}
			}
			
			if (this.menuItems.length && ((party['party_type'] === 2) || (party['party_type'] === 3)) && (parseInt(this.commonService.assessmentYear, 10) != 2019)) {
				const deductionModules = this.menuItems;
				const deductionComponentData = deductionModules.filter(menu => menu.state === 'dashboard/incomes');
				const deductionComponentIndex = deductionModules.indexOf(deductionComponentData[0]);
				const deductionSubModules = this.menuItems[deductionComponentIndex]['sub'];
				const deductionSubComponentData = deductionSubModules.filter(menu => menu.state === 'salary-income');
				const deductionSubComponentIndex = deductionSubModules.indexOf(deductionSubComponentData[0]);
				if (deductionSubComponentIndex >= 0) {
					deductionSubModules.splice(deductionSubComponentIndex, 1);
					this.menuItems[deductionComponentIndex]['sub'] = deductionSubModules;
				}
			}

			// // Hide TDS-1 & Schedule 5A in HUF & ITR2 Start
			if (this.menuItems.length && ((party['party_type'] === 2) && (this.commonService.selectedItrId === 2))) {
				const partAModules = this.menuItems;
				const partAComponentData = partAModules.filter(menu => menu.state === 'dashboard');
				const partAComponentIndex = partAModules.indexOf(partAComponentData[0]);
				const partASubModules = this.menuItems[partAComponentIndex]['sub'];
				const partASubComponentData = partASubModules.filter(menu => menu.state === 'part-general/schedule5a');
				const partASubComponentIndex = partASubModules.indexOf(partASubComponentData[0]);
				if (partASubComponentIndex >= 0) {
					partASubModules.splice(partASubComponentIndex, 1);
					this.menuItems[partAComponentIndex]['sub'] = partASubModules;
				}

				const taxesPaidModules = this.menuItems;
				const taxesComponentData = taxesPaidModules.filter(menu => menu.state === 'dashboard/taxes-paid');
				const taxesPaidComponentIndex = taxesPaidModules.indexOf(taxesComponentData[0]);

				const taxesPaidSubModules = this.menuItems[taxesPaidComponentIndex]['sub'];
				const taxesPaidSubComponentData = taxesPaidSubModules.filter(menu => menu.state === 'tax-deducted');
				const taxesPaidSubComponentIndex = taxesPaidSubModules.indexOf(taxesPaidSubComponentData[0]);

				const taxesPaidInnerSubModules = (this.menuItems[taxesPaidComponentIndex]['sub'])[taxesPaidSubComponentIndex]['sub'];
				const taxesPaidInnerSubComponentData = taxesPaidInnerSubModules.filter(menu => menu.state === 'tds-1');
				const taxesPaidInnerSubComponentIndex = taxesPaidInnerSubModules.indexOf(taxesPaidInnerSubComponentData[0]);

				if (taxesPaidInnerSubComponentIndex >= 0) {
					taxesPaidInnerSubModules.splice(taxesPaidInnerSubComponentIndex, 1);
					(this.menuItems[taxesPaidComponentIndex]['sub'])[taxesPaidSubComponentIndex]['sub'] = taxesPaidInnerSubModules;
				}
			}
			// Hide TDS-1 & Schedule 5A in HUF & ITR2 End

			// if (this.commonService.selectedItrId != 3 && this.commonService.assessmentYear && (parseInt(this.commonService.assessmentYear, 10) !== 2020)) {
			// 	if (this.menuItems.length) {
			// 		const deductionModules = this.menuItems;
			// 		const deductionComponentData = deductionModules.filter(menu => menu.state === 'dashboard/schedule-tpsa');
			// 		const deductionComponentIndex = deductionModules.indexOf(deductionComponentData[0]);
			// 		if (deductionComponentIndex >= 0) {
			// 			deductionModules.splice(deductionComponentIndex, 1);
			// 			this.menuItems = deductionModules;
			// 		}
			// 	}
			// }
			this.hasIconTypeMenuItem = !!this.menuItems.filter(item => item.type === 'icon').length;
		});
		this.layoutConf = this.layout.layoutConf;
	}

	ngAfterViewInit() { }

	ngOnDestroy() {
		if (this.menuItemsSub) {
			this.menuItemsSub.unsubscribe();
		}
	}

	toggleCollapse() {
		if (this.layoutConf.sidebarCompactToggle) {
			this.layout.publishLayoutChange({
				sidebarCompactToggle: false,
			});
		} else {
			this.layout.publishLayoutChange({
				sidebarCompactToggle: true,
			});
		}
	}
}
